import { useEffect } from "react";

export const useImageMapResizer = () => {
  useEffect(() => {
    import("image-map-resizer").then((module) => module.default());
  }, []);
};
